/*
 * Creator and referral attribution, carried over from the Lovable storefront.
 *
 * - ?ref=<code> on any page is remembered for 30 days as "ref".
 * - If the code is on the creator list (theme settings > Creator links), it is
 *   also remembered for 30 days as "creator". all-star.clothing/<creator> is a
 *   Shopify URL redirect to /?ref=<creator>, so short links land here too.
 * - Both are written onto the Shopify cart as attributes, so they show on the
 *   order. Attribution must never get in the way of shopping: every step fails
 *   silently.
 *
 * Storage keys match the Lovable site ("affiliate-ref", "as_creator"), so a
 * visitor who arrived before the switch keeps their attribution after it.
 */
(function () {
  var REF_KEY = 'affiliate-ref';
  var CREATOR_KEY = 'as_creator';
  var WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

  var config = window.allStar || {};
  var slugs = (config.creatorSlugs || [])
    .map(function (s) { return String(s).trim().toLowerCase(); })
    .filter(Boolean);

  function isCreator(slug) {
    return typeof slug === 'string' && slugs.indexOf(slug.toLowerCase()) !== -1;
  }

  function read(key) {
    try { return JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  function write(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function forget(key) {
    try { window.localStorage.removeItem(key); } catch (e) {}
  }

  function capture() {
    var code;
    try { code = (new URLSearchParams(window.location.search).get('ref') || '').trim(); } catch (e) { return; }
    if (!code) return;
    write(REF_KEY, { code: code, ts: Date.now() });
    if (isCreator(code)) write(CREATOR_KEY, { creator: code.toLowerCase(), captured_at: new Date().toISOString() });
  }

  // A creator short link (all-star.clothing/<creator>) counts the same as ?ref=<creator>.
  function captureCreator(slug) {
    if (!isCreator(slug)) return;
    write(REF_KEY, { code: slug.toLowerCase(), ts: Date.now() });
    write(CREATOR_KEY, { creator: slug.toLowerCase(), captured_at: new Date().toISOString() });
  }

  function activeRef() {
    var stored = read(REF_KEY);
    if (!stored || !stored.code || typeof stored.ts !== 'number') return null;
    if (Date.now() - stored.ts > WINDOW_MS) { forget(REF_KEY); return null; }
    return stored.code;
  }

  function activeCreator() {
    var stored = read(CREATOR_KEY);
    if (!stored) return null;
    var at = typeof stored.captured_at === 'string' ? Date.parse(stored.captured_at) : NaN;
    var age = Date.now() - at;
    if (!isCreator(stored.creator) || !isFinite(at) || age < 0 || age >= WINDOW_MS) {
      forget(CREATOR_KEY);
      return null;
    }
    return stored.creator;
  }

  function attributes() {
    var attrs = {};
    var ref = activeRef();
    var creator = activeCreator();
    if (ref) attrs.ref = ref;
    if (creator) attrs.creator = creator;
    return attrs;
  }

  // Writes the attributes onto the current cart. Shopify merges cart
  // attributes, so anything else on the cart is left alone.
  function syncCart() {
    var attrs = attributes();
    if (!attrs.ref && !attrs.creator) return Promise.resolve();
    var url = ((config.routes && config.routes.cartUpdate) || '/cart/update') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  capture();

  window.asAttribution = {
    isCreator: isCreator,
    captureCreator: captureCreator,
    activeRef: activeRef,
    activeCreator: activeCreator,
    attributes: attributes,
    syncCart: syncCart
  };

  // Attributed visitors get the cart stamped on every page view, so a cart
  // created later in the visit (or after a finished checkout) is covered too.
  if (attributes().ref || attributes().creator) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCart);
    else syncCart();
  }
})();
